import React from "react";
import "./Spacer.css";

function Spacer({ size = "100vh", className = "" }) {
  return (
    <div
      className={`spacer ${className}`}
      style={{ height: `${size}vh` }}
      aria-hidden="true"
    />
  );
}

export default Spacer;
